import {
  fetch,
  normalize,
  extractHubURL,
} from '../../utils/dataAccess';
import {filterAction, sortAction} from "../../utils/filterAndSortUtils";

export function error(error) {
  return { type: 'ONEWAYINTERVIEW_SHARE_LINK_LIST_ERROR', error };
}

export function loading(loading) {
  return { type: 'ONEWAYINTERVIEW_SHARE_LINK_LIST_LOADING', loading };
}

export function success(retrieved) {
  return { type: 'ONEWAYINTERVIEW_SHARE_LINK_LIST_SUCCESS', retrieved };
}

export function list(page = 'one_way_interview_share_links') {
  return dispatch => {
    dispatch(loading(true));
    dispatch(error(''));

    fetch(page)
      .then(response =>
        ({ retrieved: response.data, hubURL: extractHubURL(response) })
      )
      .then(({ retrieved, hubURL }) => {
        retrieved = normalize(retrieved);

        dispatch(loading(false));
        dispatch(success(retrieved));
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function reset() {
  return dispatch => {
    dispatch(success(null));
    dispatch(loading(null));
    dispatch(error(null));
  };
}

export function filter(filtersData) {
  return filterAction('ONEWAYINTERVIEW_SHARE_LINK_LIST_FILTER', 'one_way_interview_share_links', filtersData)
}

export function sort(sortData) {
  return sortAction('ONEWAYINTERVIEW_SHARE_LINK_LIST_SORT', 'one_way_interview_share_links', sortData)
}
